/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I add a separator between copies?`)
};

const es_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo agrego un separador entre copias?`)
};

const de_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie füge ich ein Trennzeichen zwischen den Kopien hinzu?`)
};

const nl_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe voeg ik een scheidingsteken toe tussen kopieën?`)
};

const fr_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ajouter un séparateur entre les copies?`)
};

const it_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come aggiungo un separatore tra le copie?`)
};

const pt_br2_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço para adicionar um separador entre as cópias?`)
};

const pt_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como adiciono um separador entre cópias?`)
};

const ja_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー間にセパレーターを追加するにはどうすればよいですか？`)
};

const zh_tr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何在副本之间添加分隔符？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq4_q", locale)
	if (locale === "en") return en_tr_faq4_q(inputs)
	if (locale === "es") return es_tr_faq4_q(inputs)
	if (locale === "de") return de_tr_faq4_q(inputs)
	if (locale === "nl") return nl_tr_faq4_q(inputs)
	if (locale === "fr") return fr_tr_faq4_q(inputs)
	if (locale === "it") return it_tr_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq4_q(inputs)
	if (locale === "pt") return pt_tr_faq4_q(inputs)
	if (locale === "ja") return ja_tr_faq4_q(inputs)
	return zh_tr_faq4_q(inputs)
};